module.exports = __webpack_public_path__ + "img/11.ce37fe61.jpg";